var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.linkTag,_vm._b({tag:"component",staticClass:"ds-button",class:[
    _vm.size && ("ds-button-size-" + _vm.size),
    _vm.primary && "ds-button-primary",
    _vm.secondary && "ds-button-secondary",
    _vm.danger && "ds-button-danger",
    _vm.ghost && "ds-button-ghost",
    _vm.iconOnly && "ds-button-icon-only",
    _vm.hover && "ds-button-hover",
    _vm.fullwidth && "ds-button-fullwidth",
    _vm.loading && "ds-button-loading",
    _vm.right && "ds-button-right"
  ],attrs:{"name":_vm.name},on:{"!click":function($event){return _vm.handleClick($event)}}},'component',_vm.bindings,false),[_c('div',{staticClass:"ds-button-wrap"},[(_vm.icon)?_c('ds-icon',{attrs:{"name":_vm.icon}}):_vm._e(),(_vm.$slots.default)?_c('span',{staticClass:"ds-button-text"},[_vm._t("default")],2):_vm._e()],1),(_vm.loading)?_c('ds-spinner',{attrs:{"inverse":!_vm.ghost && (_vm.primary || _vm.secondary || _vm.danger)}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }